/* navigation */
$(function(){

    var breakpoint = 992;
    var browser_width = window.innerWidth;
    var htmlbody = $('html, body');
    var burger = $('.burger');
    var navigation = $('.navigation').not('.pagination, .navigation--aux');
    li_has_child = navigation.find('ul li.menu-item-has-children');

    var launch_navigation = function launch_navigation(obj){
        obj.addClass('burger--active');
        htmlbody.addClass('--mobile');
        navigation.addClass('navigation--active');
    };

    var reset_navigation = function reset_navigation(){
        burger.removeClass('burger--active');
        htmlbody.removeClass('--mobile');
        navigation.removeClass('navigation--active');
        navigation.find('ul').removeClass('active');
    };

    $(window).click(function(event){
        if(event.target.className == "navigation navigation--active"){
            reset_navigation();
        };
    });

    burger.click(function(event){
        event.preventDefault();
        if(!htmlbody.hasClass('--mobile')){
            launch_navigation($(this));
        }else{
            reset_navigation();
        };
    });

    var create_li_nav = function create_li_nav(){
        li_has_child.each(function(){
            child_ul = $(this).children('ul');
            child_ul.each(function(){
                sibling_ahref = $(this).siblings('a').attr('href');
                sibling_title = $(this).siblings('a').html();
                $(this).prepend('<li class="menu-item--view"><a href=" ' + sibling_ahref + ' ">View ' + sibling_title +  ' </a></li>');
                $(this).prepend('<li class="menu-item--back"><a href="#">Back</a></li>');
            });
        });
    };

    var destroy_li_nav = function destroy_li_nav(){
        $('.menu-item--back').remove();
        $('.menu-item--view').remove();
    };


    var modify_menu = function modify_menu(){

        var browser_width = window.innerWidth;
        var back_li = $('.menu-item--back');
        var view_li = $('.menu-item--view');
        var parent_li = $('.navigation__menu > ul > li.menu-item-has-children');
        var child_ul = parent_li.find('ul');
        var child_ul_width = 220;

        var nav_width_checker = function nav_width_checker(){
            // console.log('nav_width_checker running');
            sub_menu_total = parseInt(parent_li.length * child_ul_width);

            parent_li.each(function(i){
                var child_ul_pos = ($(window).width() - ($(this).offset().left + $(this).width()));
                // console.log('from right ' + child_ul_pos);
                if(sub_menu_total >= child_ul_pos){
                    // console.log('overlap');
                    $(this).addClass('menu-item-has-children--offsetmenu');
                }else if(sub_menu_total < child_ul_pos){
                    // console.log('in view');
                    $(this).removeClass('menu-item-has-children--offsetmenu');
                };
            });
        };

        var destroy_offset = function destroy_offset(){
            parent_li.removeClass('menu-item-has-children--offsetmenu');
        }

        if(browser_width < 992){
            destroy_offset()
            if(back_li.length < 1 && view_li.length < 1){
                create_li_nav();
            }
        }else if(browser_width > 991){
            nav_width_checker();
            parent_li.removeClass('offset');
            if(back_li.length > 0 && view_li.length > 0){
                destroy_li_nav();
            }
        };

        parent_li.find('a').click(function(event){
            var browser_width = window.innerWidth;
            if(browser_width < 992){
                if($(this).siblings('ul').length > 0){
                    event.preventDefault();
                    $(this).siblings('ul').addClass('active');
                };
            };
        });


        var back_li = $('.menu-item--back');
        var view_li = $('.menu-item--view');
        back_li.on('click', function(event){
            event.preventDefault();
            $(this).parent('ul').removeClass('active');
        });
        view_li.on('click', function(event){
            event.stopPropagation();
        });
    };

    modify_menu();

    var resizeTimer;
    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            modify_menu();
        }, 250);
    });
});


/* checkbox */
$(function(){
    var form_checkbox = $('.formfield--checkbox').find('input');
    form_checkbox.click(function(){
        if($(this).is(':checked')){
            $(this).parent().addClass('--checked');
        }else{
            $(this).parent().removeClass('--checked');
        }
    });
});
/* checkbox */

/* checkbox CF7 */
$(function(){
    var form_checkbox = $('.wpcf7-checkbox .wpcf7-list-item-label');
    form_checkbox.click(function(){
        if($(this).siblings('input').is(':checked')){
            $(this).removeClass('--checked');
            $(this).siblings('input').prop('checked', false);
        }else{
            $(this).addClass('--checked');
            $(this).siblings('input').prop('checked', true);
        }
    });
});
/* checkbox CF7 */


/* radio */
$(function(){
    var form_radio = $('.formfield--radio').find('input');
    form_radio.click(function(){
        console.log(this.checked);
        if($(this).is(':checked')){
            $(this).parents('.formfield__input').find('label').removeClass('--checked');
            $(this).parent().addClass('--checked');
        }
    });
});
/* radio */

/* radio CF7 */
$(function(){
    var form_radio = $('.wpcf7-radio .wpcf7-list-item-label');
    form_radio.click(function(){
        $(this).parents('.wpcf7-radio').find('.wpcf7-list-item-label').removeClass('--checked');
        $(this).parents('.wpcf7-radio').find('input').prop('checked', false);
        $(this).siblings('input').prop('checked', true);
        $(this).addClass('--checked');
    });
});
/* radio */


/* woof filter */
$(document).on('change', '.woof_list li input', function(){
    if($(this).parents('label').hasClass('__checked')){
        $(this).parents('label').removeClass('__checked');
        $(this).parent().removeClass('__checked');
    }else{
        $(this).parents('label').addClass('__checked');
        $(this).parent().addClass('__checked');
    }
});
$(function(){
    var empty_item = $('.woof_list input:disabled').css({ 'background' : 'red' });
    empty_item.parent('li').hide();
});
/* woof filter */


/* tabs */
$(function(){
    var tabblock = $('.tabsblock');
    var tabitem = $('.tabsblock__tabitem');
    var contentitem = $('.tabsblock__contentitem');

    tabblock.each(function(){
        $(this).find('.tabsblock__tabitem').eq(0).addClass('tabsblock__tabitem--active');
        $(this).find('.tabsblock__contentitem').eq(0).addClass('tabsblock__contentitem--active');
    });

    tabitem.click(function(event){
        event.preventDefault();
        $(this).parents('.tabsblock').find('.tabsblock__tabitem').removeClass('tabsblock__tabitem--active');
        $(this).addClass('tabsblock__tabitem--active');
        var data_tab = $(this).data('tab');
        $(this).parents('.tabsblock').find('.tabsblock__contentitem').removeClass('tabsblock__contentitem--active');
        $(this).parents('.tabsblock').find('.tabsblock__contentitem').filter('[data-tab="' + data_tab + '"]').addClass('tabsblock__contentitem--active');
    });
});


/* accordionblock */
$(function(){
    var accordion = $('.accordionblock');
    var toggle = accordion.find('.accordionblock__head');

    toggle.click(function(event){
        event.preventDefault();
        $(this).parents('.accordionblock').toggleClass('accordionblock--active');
        $(this).siblings().toggle();
        if($(this).attr('aria-expanded') === 'true'){
            $(this).attr('aria-expanded', 'false');
        }else{
            $(this).attr('aria-expanded', 'true');
        }
    });
});


/* video block */
$(function(){
    $(".videoblock__video").magnificPopup({
        type: "iframe",
        removalDelay: 160,
        preloader: !1,
        fixedContentPos: !1
    })
});

/* modal */
$(function(){
    var modal_launch = $('.modallaunch');
    var modalitem = $('.modalitem');
    var modalclose = $('.modalitem__close');

    modal_launch.click(function(event){
        event.preventDefault();
        var modal_id = $(this).data('modalid')
        modalitem.filter('[data-modalid="' + modal_id + '"]').addClass('modalitem--active');
    });
    modalclose.click(function(){
        modalitem.removeClass('modalitem--active');
    });
    $(window).click(function(event){
        if(event.target.className == "modalitem modalitem--active"){
            modalitem.removeClass('modalitem--active');
        };
    });
    $(document).keyup(function(event) {
        if (event.keyCode == 27) {
            $('.modalitem .modalitem--active').removeClass('modalitem--active');
        };
    });
});
